<template>
    <div v-loading.fullscreen.lock="fullscreenLoading"></div>
</template>

<script>
  export default {
    name: 'Callback',
    data () {
      return {
        fullscreenLoading: false
      }
    },
    methods: {
      async handleAuth () {
        try {
          this.$store.dispatch('auth/login')
          this.fullscreenLoading = false
        } catch (err) {
          console.log('Error in callback: Authentication failed')
          this.fullscreenLoading = false
          this.$router.replace({name: 'login.index'})
        }
      }
    },
    created () {
      this.fullscreenLoading = true
      this.handleAuth()
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/components/Callback.vue